import { PanelColorSettings } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

export default function ColorsControls({ attributes, setAttributes }) {
  const handleChangeNavigationValue = (key, value) => {
    setAttributes({
      navigation: {
        ...attributes.navigation,
        [key]: value,
      },
    });
  };
  const handleChangePaginationValue = (key, value) => {
    setAttributes({
      pagination: {
        ...attributes.pagination,
        [key]: value,
      },
    });
  };
  const handleChangeScrollbarValue = (key, value) => {
    setAttributes({
      scrollbar: {
        ...attributes.scrollbar,
        [key]: value,
      },
    });
  };
  return (
    <PanelColorSettings
      title={__("Colors", "brandy-blocks")}
      initialOpen={false}
      enableAlpha={true}
      colorSettings={[
        ...(attributes.navigation.enabled ?? true
          ? [
              {
                value: attributes.navigation?.iconColor,
                onChange: (v) => {
                  handleChangeNavigationValue("iconColor", v);
                },
                clearable: true,
                label: __("Navigation arrow", "brandy-blocks"),
              },
              {
                value: attributes.navigation?.iconHoverColor,
                onChange: (v) => {
                  handleChangeNavigationValue("iconHoverColor", v);
                },
                clearable: true,
                label: __("Navigation arrow hover", "brandy-blocks"),
              },
              {
                value: attributes.navigation?.backgroundColor,
                onChange: (v) => {
                  handleChangeNavigationValue("backgroundColor", v);
                },
                clearable: true,
                label: __("Navigation button", "brandy-blocks"),
              },
              {
                value: attributes.navigation?.backgroundHoverColor,
                onChange: (v) => {
                  handleChangeNavigationValue("backgroundHoverColor", v);
                },
                clearable: true,
                label: __("Navigation button hover", "brandy-blocks"),
              },
            ]
          : []),
        ...(attributes.pagination.enabled
          ? [
              {
                value: attributes.pagination?.defaultColor,
                onChange: (v) => {
                  handleChangePaginationValue("defaultColor", v);
                },
                clearable: true,
                label: __("Pagination bullet", "brandy-blocks"),
              },
              {
                value: attributes.pagination?.activeColor,
                onChange: (v) => {
                  handleChangePaginationValue("activeColor", v);
                },
                clearable: true,
                label: __("Pagination bullet active", "brandy-blocks"),
              },
            ]
          : []),
        ...(attributes.scrollbar.enabled
          ? [
              {
                value: attributes.scrollbar?.defaultColor,
                onChange: (v) => {
                  handleChangeScrollbarValue("defaultColor", v);
                },
                clearable: true,
                label: __("Scrollbar color", "brandy-blocks"),
              },
              {
                value: attributes.scrollbar?.activeColor,
                onChange: (v) => {
                  handleChangeScrollbarValue("activeColor", v);
                },
                clearable: true,
                label: __("Scrollbar active color", "brandy-blocks"),
              },
            ]
          : []),
      ]}
    />
  );
}
